import { render } from "./TheHeader.vue?vue&type=template&id=9ab530c6&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=9ab530c6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab530c6"]])

export default __exports__